import React, { useState } from "react";
import { Text, View } from "@/styles/reactnative";

import { GoogleTrendSection, GoogleTrendsHeader } from "./styles";
import MarketTrendHeader from "../MarketTrendHeader";
import MarketTrendTabs from "../MarketTrendTabs";
import GoogleTrendsGraph from "./GoogleTrendsGraph";
import { useTranslation } from "react-i18next";

const TrendingSocial = () => {
  const { t } = useTranslation();
  const [tab, setTab] = useState("3m");
  const tabs = ["3m", "6m", "1y"];

  return (
    <View style={{ alignItems: "flex-start" }}>
      <MarketTrendHeader title={"trendingOnSocialMedia"} />
      <GoogleTrendSection>
        <GoogleTrendsHeader>
          <Text size={14} style={{ fontWeight: "600" }}>
            {t("BTCOnGoogleTrends")}
          </Text>
          <MarketTrendTabs tab={tab} setTab={setTab} tabs={tabs} />
        </GoogleTrendsHeader>
        <GoogleTrendsGraph />
      </GoogleTrendSection>
    </View>
  );
};

export default React.memo(TrendingSocial);
